export default __webpack_public_path__ + "static/media/failure-illustration.7cac8560.svg";